import { PrizeStocksInterface } from '~/models/interfaces/PrizeHub'

import api from '~/config/api'
import { basePrizeHub } from '~/config/basePath'

const pathUrlV2 = `${basePrizeHub}/v2/prize-draw`

const getPreview = async (params: { campaignSlug: string }) => {
  const { campaignSlug } = params

  const { data } = await api.get<PrizeStocksInterface>(
    `${pathUrlV2}/queries/commercial-campaign/${campaignSlug}/prize-stocks/preview`,
  )

  return data
}

const getPrizes = async (params: { campaignSlug: string; contractNumber: string }) => {
  const { campaignSlug, contractNumber } = params

  const { data } = await api.get<PrizeStocksInterface>(
    `${pathUrlV2}/queries/contract/${contractNumber}/commercial-campaign/${campaignSlug}/prize-stocks`,
  )

  return data
}

const sendPrizeViewed = async (params: { contractNumber: string; campaignSlug: string }) => {
  const { campaignSlug, contractNumber } = params

  await api.put(
    `${pathUrlV2}/contract/${contractNumber}/commercial-campaign/${campaignSlug}/viewed`,
  )
}

export const PrizeDrawService = { getPreview, getPrizes, sendPrizeViewed }
